import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface SignatureDocumentContainerProps {
  isExpanded: boolean
}

export const SignatureDocumentContainer = styled.div<SignatureDocumentContainerProps>`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  width: ${(props) => (props.isExpanded ? '70vw' : '50vw')};
  padding: 0 ${Spacing.S24};
`

export const IframeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const ButtonPositioner = styled.div`
  position: absolute;
  top: 58%;
  left: 50%;
  transform: translate(-50%, -50%);

  /* Setting various breakpoints to overlay the continue button based on the */
  /* iframe from Yousign. */
  /* Desktop screens */
  @media (max-height: 1080px) {
    top: 66%;
  }
  /* Small desktop screens */
  @media (max-height: 968px) {
    top: 71%;
  }
  /* Tablet screens */
  @media (max-height: 831px) {
    top: 78%;
  }
  /* Small tablet screens */
  @media (max-height: 768px) {
    top: 82%;
  }
`
